import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DateSelect from "../XoSoSidebar/DateSelect";
import useThanTai04 from "../ThanTai04/useThanTai04";
import { PRODUCT, TZ } from "../ThanTai04/constants";
import CompactResult from "./CompactResult";
import "../XoSoSidebar/XoSoSidebar.css";
import "./SidebarThanTai04.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function SidebarThanTai04({ defaultDate, dataDefault, config }) {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(defaultDate || dataDefault || config?.date || null);
  const { results, loading, resolvedDate } = useThanTai04(date, 1);
  const selectedDate = date || resolvedDate || today;

  return (
    <div className="xoso-sidebar tt04-sidebar">
      <div className="xoso-sidebar__head">
        <div className="xoso-sidebar__title">
          KQXS <span>{PRODUCT}</span>
        </div>
        <DateSelect value={selectedDate} onChange={setDate} maxDate={today} />
      </div>
      <CompactResult result={results[0]} date={selectedDate} loading={loading} />
    </div>
  );
}

SidebarThanTai04.DateSelect = DateSelect;
SidebarThanTai04.Result = CompactResult;

export { DateSelect, CompactResult };
export default SidebarThanTai04;
